const courseConfigs = {
  baze: {
    courseId: 1,
    courseName: 'Bazele contabilitatii',

    chaptersUrl: '/chapters',
    titlesUrl: '/chapters/titles',
    progressUrl: '/user/lesson-progress',

    lessonUrl: (chapterId, lessonId) =>
      `/chapter/${chapterId}/lesson/${lessonId}`,

    theme: {
      primary: '#13b8ab',
      light: '#16c79e',
      dark: '#089182',
      darker: '#11997b'
    }
  },

  financiara: {
    courseId: 2,
    courseName: 'Contabilitate financiara',

    chaptersUrl: '/financial/chapters',
    titlesUrl: '/financial/chapters/titles',
    progressUrl: '/user/financial-lesson-progress',

    lessonUrl: (chapterId, lessonId) =>
      `/financial/chapter/${chapterId}/lesson/${lessonId}`,

    theme: {
      primary: '#F59E0B',
      light: '#FBBF24',
      dark: '#D97706',
      darker: '#B45309'
    }
  }
};

export default courseConfigs;